import {
  Box,
  Button,
  Card,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";

const ConfirmModal = ({ open, onClose, onConfirm, title, isLoading }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 400,
          px: 3,
          py: 6,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <img src={icons.warn} alt="warn" />
        <Typography sx={{ fontSize: "1.5rem", fontWeight: "600", my: "3rem" }}>
          {title}
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: "#1E1E1E",
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              py: ".9rem",
              fontSize: "1rem",
              width: "120px",
              "&:hover": { backgroundColor: "#000" },
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              width: "120px",
            }}
          >
            {isLoading ? (
              <CircularProgress
                size={28}
                sx={{
                  color: "#fff",
                }}
              />
            ) : (
              "Yes"
            )}
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default ConfirmModal;
